import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
    selector: 'app-spinner',
    imports: [CommonModule],
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
    encapsulation: ViewEncapsulation.ShadowDom
})
export class SpinnerComponent implements OnInit {
  loading$ = this.loader.loading$;

  constructor(public loader: LoaderService) {}

  ngOnInit(): void {}
}